module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "top-slide"
    }
  }, [_c('div', {
    staticClass: "update-prompt"
  }, [_c('div', {}, [_c('h3', [_vm._v(_vm._s(_vm.$t('update_available')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('update_prompt')))])]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.reload
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-refresh"
  }), _vm._v("\n      " + _vm._s(_vm.$t('update')) + "\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26f83603"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UpdatePrompt.vue
// module id = 1026
// module chunks = 1